import Big from "big.js";
import * as Yup from "yup";

/**
 * Convert server decimal percent (0-1) to form percent (0-100)
 */
export const serverToFormPercent = (decimalPct) =>
  Big(decimalPct || 0).times(100);

/**
 * Convert form percent (0-100) to server decimal percent (0-1)
 */
export const formToServerPercent = (formPct) => Big(formPct || 0).div(100);

export const percentYup = (label, required = false, min = 0, max = 100) => {
  let schema = Yup.number()
    .typeError(`${label} must be a number`)
    .min(min, `Must be at least ${min}%`)
    .max(max, `Cannot exceed ${max}%`)
    .test("max-5-decimals", "No more than 5 decimal places", (value) => {
      if (value === undefined || value === null)
        return !required ? true : false;
      const valueStr = value.toString();
      return /^(\d+)(\.\d{0,5})?$/.test(valueStr);
    });
  if (required) schema = schema.required("Required");
  return schema;
};
